import { render } from "./UnsavedDataModal.vue?vue&type=template&id=5aaa5537&scoped=true"
import script from "./UnsavedDataModal.vue?vue&type=script&lang=js"
export * from "./UnsavedDataModal.vue?vue&type=script&lang=js"

import "./UnsavedDataModal.vue?vue&type=style&index=0&id=5aaa5537&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaa5537"]])

export default __exports__